import { Transform, Type } from "class-transformer";
import Category from "../../category";
import AssetType from "./assetType";

export default class Security {
  /** Asset type to which this security belongs to. */
  @Type(() => AssetType)
  assetType: AssetType | undefined;
  /** Default category of this security. If undefined, it is expected that the user chooses a category for the security. */
  @Type(() => Category)
  defaultCategory: Category | undefined;
  /** Maturity date of this security. */
  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  maturity?: Date;

  /**
   * @param id GUID of this security.
   * @param symbol Human understood representation of the security.
   * @param description
   * @param isin ISIN code of this security.
   * @param cnpj CNPJ of this security. In Brazil, CNPJ is the main ID for companies.
   * @param maturity Maturity date of this security.
   * @param assetType Asset type to which this security belongs to.
   * @param defaultCategory Default category of this security. If undefined, it is expected that the user chooses a category for the security.
   */
  constructor(
    public id: string | undefined,
    public symbol: string,
    public description: string,
    public isin?: string,
    public cnpj?: string,
    maturity?: Date,
    assetType?: AssetType,
    defaultCategory?: Category
  ) {
    this.maturity = maturity;
    this.assetType = assetType;
    this.defaultCategory = defaultCategory;
  }
}